// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.discriminatorycontent.RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent,
  RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  CheckDiscriminatoryContentResponseV2WebDto,
  CheckDiscriminatoryContentV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Options =
  UseQueryOptions<
    CheckDiscriminatoryContentResponseV2WebDto,
    unknown,
    CheckDiscriminatoryContentResponseV2WebDto,
    readonly [string, CheckDiscriminatoryContentV2RequestDto]
  >;

const RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_GetKey = (
  postData: CheckDiscriminatoryContentV2RequestDto,
) => [RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Path, postData] as const;

export const RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_queryOptions = (
  postData: CheckDiscriminatoryContentV2RequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_GetKey(postData),
    queryFn: () =>
      RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Check whether the supplied text contains discriminatory content for a manual listing
 */
export const useRentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent = (
  postData: CheckDiscriminatoryContentV2RequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_queryOptions(postData, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent.getKey =
  RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_GetKey;
